import React, { useState, useEffect, useRef } from 'react';
import './MainHeader.style.css';
import {
  //DepthMenu,
  // Slider,
  // Switch,
  SearchLayout,
  OutsideClickHandler,
  ModalLayout,
} from 'components';
import { MenuOutlined, SearchOutlined, TruckOutlined } from '@ant-design/icons';
import {
  Button,
  Flex,
  Input,
  //Spin,
  Dropdown,
} from 'antd';
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import CartIcon from 'assets/icon/cart_icon.svg';
import UserIcon from 'assets/icon/user_icon.svg';
import MenuIcon from 'assets/icon/menu_icon.svg';
import HomeIcon from 'assets/icon/home_icon.svg';
// import SearchIcon from 'assets/icon/search_icon.png';
import SearchIcon from 'assets/icon/search_icon.svg';
import ServiceIcon from 'assets/icon/service_icon.svg';

import { Badge } from 'antd';
import MessageAlert, { deleteCookie, isMobile } from 'utils';
import { useUserAction, useUserStack, useUserDataAction } from 'store';
import { useGetSearchWords } from 'hooks/SearchWordHooks';
import MobileSideMenu from 'routes/main.routes/Mypage/components/MobileSideMenu';
import MobileCsMenu from 'routes/main.routes/Help/components/MobileCsMenu';
import MobileAllMenu from '../MobileAllMenu';
import MobileSearch from '../MobileSearch/MobileSearch';
//import { handleSearchKeyword } from 'utils/SearchKeyword';
import RecursiveMenu from '../RecursiveMenu';
// import { encrypt } from 'utils/Crypto';

const recommendList = [
  {
    id: 1,
    title: '프레도 델리카토',
  },
  {
    id: 2,
    title: '프레도 인텐소',
  },
  {
    id: 3,
    title: '콜롬비아',
  },
  {
    id: 4,
    title: '카프리치오',
  },
  {
    id: 5,
    title: '파리',
  },
];

const popularList = [
  {
    title: '스페셜블렌드',
    order: 1,
    event: 'up',
  },
  {
    title: '버츄오 플러스 매트 블랙',
    order: 2,
    event: 'new',
  },
  {
    title: '버츄오 머그 컵 세트',
    order: 3,
    event: 'down',
  },
  {
    title: '노마드 트래블 머그 라지, 라테',
    order: 4,
    event: 'keep',
  },
  {
    title: '뷰 큐브',
    order: 5,
    event: 'new',
  },
  {
    title: '버츄오 디스커버리 셀렉션 100팩',
    order: 6,
    event: 'up',
  },
  {
    title: '칸투치니',
    order: 7,
    event: 'keep',
  },
  {
    title: '더블 에스프레소 돌체',
    order: 8,
    event: 'down',
  },
  {
    title:
      '네스프레소 시럽 키트, 바닐라맛&캐러멜맛 네스프레소 시럽 키트, 바닐라맛&캐러멜맛네스프레소 시럽 키트, 바닐라맛&캐러멜맛네스프레소 시럽 키트, 바닐라맛&캐러멜맛',
    order: 9,
    event: 'up',
  },
  {
    title: '솔레리오',
    order: 10,
    event: 'up',
  },
];

/* const DropDownMenu = ({ isOpened = false, menus }) => {
  // const [activeIndex, setActiveIndex] = useState(0);

  if (!isOpened) return null;

  return (
    <div className="header_dropdown">
      <div className="header_dropdown_container">
        <div className="header_dropdown_category">
          <ul>
            {menus.map((_item, _index) => (
              <li key={`menu_${_index}`}>
                <DepthMenu item={_item} />
              </li>
            ))}
          </ul>
        </div>
        <div className="header_dropdown_swiper">
          <div className="header_dropdown_swiper_title">
            <h4>기획전</h4>
            <ul>
              {promotionList.map((_item, _index) => (
                <li
                  key={_index}
                  className={`${activeIndex === _index ? 'active' : ''}`}
                >
                  <span></span>
                </li>
              ))}
            </ul>
          </div>
          <div className="header_dropdown_swiper_content">
            <Slider
              items={promotionList}
              render={({ id, src }) => (
                <img src={src} alt={`promotion_${id}`} />
              )}
              modules={['Autoplay']}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}; */

/* 모바일 전체메뉴 드롭다운 */
/* const AllMenu = ({ isOpened = false, navigate, setIsAllDropped }) => {
  if (!isOpened) return null;

  return (
    <div className="header_dropdown mobile">
      <div className="header_dropdown_container">
        <div className="header_dropdown_category">
          <ul>
            {[
              {
                title: '베스트',
                path: '/products?type=best',
              },
              {
                title: '신상품',
                path: '/products?type=new',
              },
              // {
              //   title: 'Promotions',
              //   path: '/products?type=promotions',
              // },
              {
                title: '브랜드관',
                path: `/brand`,
              },
              // {
              //   title: '정기배송',
              //   path: '/products?type=subscription',
              // },
              {
                title: '렌탈',
                path: '/products?type=rental',
              },
              {
                title: '선물하기',
                path: '/products?type=present',
              },
              {
                title: 'JM Event',
                path: '/events',
              },
              // {
              //   title: 'Recipe',
              //   path: '/products?category=recipe',
              // },
            ].map((item, index) => (
              <li
                key={`top_menu_${index}`}
                className="cursorOverOpacity"
                onClick={() => {
                  navigate(item.path); // 페이지 이동
                  setIsAllDropped(false); // 메뉴 닫기
                }}
              >
                {item.title}
              </li>
            ))}
            <li>
              <a href="https://jmcoffee.co.kr" target="_blank">
                <button style={{ fontWeight: 'normal' }}>제이엠커피그룹</button>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}; */
/**----------------------------------------
 * [Component] 메인헤더
 * ----------------------------------------
 */
const MainHeader = ({
  maxWidth = 1060,
  logo,
  backgroundColor = '#FFFFFF',
  isLogin = false,
  categories = [],
  screenSize,
  name = '',
  onLogout,
  cartNum = 0,
  setLoading = false,
  isWebView = false,
}) => {
  /* ===== Route ===== */
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get('keyword');

  const userAction = useUserAction();
  /* ===== category ===== */
  // const coffeeCategory = categories?.find((item) => item.title === "커피");
  // const machineCategory = categories?.find((item) => item.title === "머신");
  /* ===== Data ===== */
  const { data: SearchWord } = useGetSearchWords(
    {
      is_show: 'Y',
    },
    {
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) {
          return [];
        }

        return data;
      },
      initialData: [],
    },
  );

  const items = [
    {
      key: '1',
      label: <Link to={`/cs/faq`}>FAQ</Link>,
    },
    {
      key: '2',
      label: <Link to={`/cs/notice`}>공지사항</Link>,
    },
    {
      key: '3',
      label: <Link to={`/cs/inquire`}>1:1문의</Link>,
    },
    // {
    //   key: '4',
    //   label: (
    //     <a
    //       target="_blank"
    //       href="https://jmcoffee.co.kr/contact/inquire/"
    //       rel="noreferrer"
    //     >
    //       B2B PARTNERS
    //     </a>
    //   ),
    // },
    {
      key: '4',
      label: <Link to={`/cs/notice`}>매장 소식</Link>,
    },
    {
      key: '5',
      label: (
        <a
          target="_blank"
          href="https://mall.jmcoffeemall.com/jmcoffeemall.com/#/common/apply"
          rel="noreferrer"
        >
          입점제안
        </a>
      ),
    },
    {
      key: '6',
      label: (
        <a
          target="_blank"
          href="https://mall.jmcoffeemall.com/#/admin"
          rel="noreferrer"
        >
          입점사 로그인
        </a>
      ),
    },
    /* {
      key: '4',
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => navigate(`/events`)}
        >
          JM Event
        </a>
      ),
    }, */
  ];

  /* ===== Store ===== */
  const userDataAction = useUserDataAction();

  /* ===== State ===== */
  // 드롭다운 메뉴
  const [isDropped, setIsDropped] = useState(false);
  // 모바일 드롭다운 메뉴
  const [isAllDropped, setIsAllDropped] = useState(false);
  // 검색창
  const [isOpened, setIsOpened] = useState(false);
  // 검색값
  const [searchValue, setSearchValue] = React.useState('');
  const [keywordList, setKeywordList] = React.useState([]);
  const [isFocus, setIsFocus] = React.useState(false);

  const userInfo = useUserStack();
  // 모바일 전체 메뉴 모달
  const [isAllOpen, setIsAllOpen] = useState(false);
  // 모바일 마이페이지 메뉴 모달
  const [isOpen, setIsOpen] = useState(false);
  // 모바일 검색창 모달
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  // 모바일 Cs 메뉴 모달
  const [isCsOpen, setIsCsOpen] = useState(false);

  // 가로스크롤 메뉴
  const [hasScroll, setHasScroll] = useState(false);
  const [leftOpacity, setLeftOpacity] = useState(0);
  const [rightOpacity, setRightOpacity] = useState(1);

  const navRef = useRef(null);

  useEffect(() => {
    const checkScroll = () => {
      if (navRef.current) {
        const { scrollWidth, clientWidth, scrollLeft } = navRef.current;

        const isScrollable = scrollWidth > clientWidth;
        setHasScroll(isScrollable);

        setLeftOpacity(scrollLeft === 0 ? 0 : 1);
        setRightOpacity(scrollLeft + clientWidth >= scrollWidth ? 0 : 1);
      }
    };

    checkScroll(); // 최초 실행

    if (navRef.current) {
      navRef.current.addEventListener('scroll', checkScroll);
    }
    window.addEventListener('resize', checkScroll);

    return () => {
      if (navRef.current) {
        navRef.current.removeEventListener('scroll', checkScroll);
      }
      window.removeEventListener('resize', checkScroll);
    };
  }, [categories, screenSize]);

  useEffect(() => {
    const handleBackButton = () => {
      if (isAllOpen) {
        setIsAllOpen(false);
        return;
      }
      if (isOpen) {
        setIsOpen(false);
        return;
      }
      if (isSearchOpen) {
        setIsSearchOpen(false);
        return;
      }
      if (isCsOpen) {
        setIsCsOpen(false);
        return;
      }

      // 모든 모달이 닫힌 상태라면 히스토리를 원래 상태로 되돌림
      window.history.replaceState(null, '', window.location.href);
    };

    const handlePopState = () => {
      handleBackButton();
    };

    // 모달이 열릴 때 히스토리 추가
    if (isAllOpen || isOpen || isSearchOpen || isCsOpen) {
      window.history.pushState(null, '', window.location.href);
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isAllOpen, isOpen, isSearchOpen, isCsOpen]);

  /* ===== Function ===== */
  /**
   * 라우팅
   * --
   * @param {string} path
   * @param {boolean} auth
   * @returns
   */
  const handleNavigate = (path = '', auth = false) => {
    if (auth && !userInfo) {
      const confirm = '로그인 후 이용가능합니다.\n로그인하시겠습니까?';

      if (!confirm) return;

      navigate('signin', {
        state: {
          from: `${path}`,
        },
      });
    }

    navigate(path);
  };

  /**
   * 검색 라우팅 처리
   */
  const handleSearch = () => {
    if (!searchValue) {
      MessageAlert.info('검색어를 입력해주세요!');

      return;
    }

    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setIsFocus(false);
      handleNavigate(`/products?keyword=${encodeURIComponent(searchValue)}`);
    }, 1000);
  };

  /* ===== Function ===== */
  /**
   * 로그아웃
   * --
   * @returns
   */
  const handleLogout = () => {
    const confirmLogout = window.confirm('로그아웃하시겠습니까?');

    if (!confirmLogout) return;

    deleteCookie('JM_COFFEE_ACCESS_TOKEN', {});
    userAction.resetUser();
    userDataAction.resetAllData();

    if (isMobile()) {
      window.ReactNativeWebView.postMessage(
        `${JSON.stringify({ type: 'logout-success' })}`,
      );
    }

    setTimeout(() => setIsOpen(false), 0); // 메뉴 닫기
    navigate('/main'); // 메인 페이지로 이동

    MessageAlert.success('로그아웃되었습니다.');
  };

  /* ===== Hooks ===== */
  /**
   * 드롭다운 메뉴 / 검색창 라우트 이동 시 닫힘 처리
   * --
   */
  useEffect(() => {
    setIsDropped(false);
    setIsOpened(false);
  }, [navigate]);

  React.useEffect(() => {
    if (!keyword) {
      setSearchValue('');
    }
  }, [location]);

  React.useEffect(() => {
    if (keyword) {
      setSearchValue(keyword);
    } else {
      setSearchValue('');
    }
  }, [keyword]);

  /**
   * 추천 검색어 필터
   * --
   */
  /* ==== 기존 추천 검색어 필터 ==== */
  /* React.useEffect(() => {
    if (!searchValue || !SearchWord.length) {
      setIsLoading(false);
      // setIsFocus(false);
      return;
    }

    if (isFocus) {
      setIsLoading(true);

      const filterWord = handleSearchKeyword(
        SearchWord,
        searchValue,
        'search_word'
      )?.sort((a, b) => a?.order - b?.order);

      setTimeout(() => {
        setKeywordList([...filterWord]);
        setIsLoading(false);
      }, 500);
    }
  }, [searchValue, SearchWord, isFocus]); */

  /* ===== Render ===== */
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setIsDropped(false);
        setIsOpened(false);
      }}
    >
      {/* ===== 모바일 메뉴 ===== */}
      <div className="mobile_header_wrapper">
        {isWebView ? null : (
          <div
            className="mobile_header"
            style={{ backgroundColor: backgroundColor }}
          >
            <div className="inner">
              {/* 로고 */}
              <div className="header_logo" onClick={() => navigate('/main')}>
                {logo ? logo : 'Jmcoffee'}
              </div>
            </div>
          </div>
        )}

        <div
          className="mobile_nav"
          style={{ backgroundColor: backgroundColor }}
        >
          <div className="inner">
            <ul className="header_nav_icon">
              <li>
                {/* <button onClick={() => setIsOpened(true)}>
                  <img src={SearchIcon} alt="검색" />
                </button> */}
                {/* <Button
                  type="text"
                  style={{ padding: 0 }}
                  onClick={() => {
                    setIsAllDropped(!isAllDropped); // AllMenu 토글
                    setIsDropped(false); // DropDownMenu는 닫기
                  }}
                >
                  <img src={MenuIcon} alt="전체메뉴" />
                </Button> */}
                <Button
                  type="text"
                  style={{ padding: 0 }}
                  onClick={() => {
                    setIsAllOpen(true);
                  }}
                >
                  <img src={MenuIcon} alt="전체메뉴" width={20} />
                </Button>
                <span className="header_nav_icon_text">카테고리</span>
              </li>
              <li>
                <Button
                  type="text"
                  style={{ padding: 0 }}
                  onClick={() => {
                    setIsSearchOpen(true);
                  }}
                >
                  <img src={SearchIcon} alt="검색" />
                </Button>
                <span className="header_nav_icon_text">검색</span>
              </li>
              <li>
                <Button
                  type="text"
                  style={{ padding: 0 }}
                  onClick={() => {
                    handleNavigate(`/`, true);
                    setIsAllDropped(false); // 메뉴 닫기
                  }}
                >
                  <img src={HomeIcon} alt="홈" />
                </Button>
                <span className="header_nav_icon_text">홈</span>
              </li>
              <li>
                <Badge count={cartNum}>
                  <button
                    onClick={() => {
                      handleNavigate(`/order/cart?type=delivery`, true);
                      setIsAllDropped(false); // 메뉴 닫기
                    }}
                  >
                    <img src={CartIcon} alt="장바구니" />
                  </button>
                </Badge>
                <span className="header_nav_icon_text">장바구니</span>
              </li>
              <li>
                <Badge>
                  <button
                    onClick={() => {
                      setIsOpen(true);
                      setIsAllDropped(false); // 메뉴 닫기
                    }}
                  >
                    <img src={UserIcon} alt="내정보" />
                  </button>
                </Badge>
                <span className="header_nav_icon_text">내 정보</span>
              </li>
              {/* <li>
                <button>
                  <img
                    src={ServiceIcon}
                    alt="고객센터"
                    onClick={() => window.open('http://pf.kakao.com/_xiZSZn')}
                  />
                </button>
              </li> */}
            </ul>
          </div>
        </div>
      </div>

      <div className={`header_wrapper ${isWebView ? 'hide' : 'show'}`}>
        {/* ===== 상단 메뉴: start ===== */}
        <div
          className="header_layout top"
          style={{ backgroundColor: backgroundColor }}
        >
          <ul className="header_container" style={{ maxWidth: maxWidth }}>
            {/* === Left === */}
            <li className="header_content inner01">
              {/* 로고 */}
              <div
                className="header_logo"
                onClick={() => {
                  navigate('/main');
                  setIsAllDropped(false); // 메뉴 닫기
                }}
              >
                {logo ? logo : 'Jmcoffee'}
              </div>
              {/* 스위치 버튼 */}
              {/* <div className="header_toggle">
                <Switch
                  checkedChildren={'Shop'}
                  unCheckedChildren={'Order'}
                  style={{ width: '100%', height: '100%' }}
                  childrenStyle={{ fontSize: screenSize > 1500 ? 12 : 10 }}
                />
              </div> */}
            </li>

            {/* === Center === */}
            <li className="header_content inner02">
              <ul className="header_nav">
                <li style={{ position: 'relative', top: 0, left: 0 }}>
                  <OutsideClickHandler
                    onOutsideClick={() =>
                      setTimeout(() => setIsFocus(false), 300)
                    }
                  >
                    <Flex
                      gap={4}
                      style={{
                        borderBottom: '1px solid #7a7a7a',
                        paddingBottom: 4,
                      }}
                    >
                      <Input
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        variant="borderless"
                        onPressEnter={() => handleSearch()}
                        allowClear
                        //onFocus={() => setIsFocus(true)}
                        onFocus={() => {
                          setIsFocus(true);
                          setKeywordList(
                            SearchWord?.sort((a, b) => a?.order - b?.order),
                          ); // 전체 추천어 바로 세팅
                        }}

                        // onBlur={() => setIsFocus(false)}
                      />
                      <SearchOutlined
                        className="search"
                        style={{ fontSize: '1.3em' }}
                        onClick={() => handleSearch()}
                      />
                    </Flex>
                  </OutsideClickHandler>
                  {isFocus ? (
                    <ul className="header-keyword-wrap">
                      <li
                        style={{
                          width: '100%',
                          textAlign: 'start',
                          fontWeight: 700,
                          marginBottom: 10,
                        }}
                      >
                        추천 검색어
                      </li>
                      {keywordList?.map((item, index) => (
                        <li
                          key={`word-${index}`}
                          className="header-keyword"
                          onClick={(e) => {
                            e.preventDefault();
                            setSearchValue(item.search_word);
                            setIsFocus(false);
                          }}
                        >
                          {item.search_word}
                        </li>
                      ))}
                    </ul>
                  ) : null}

                  {/* ==== 기존 추천 검색어 드롭다운 ==== */}
                  {/* {isFocus && searchValue ? (
                    <ul
                      style={{
                        width: '100%',
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        boxShadow: 'rgba(0, 0, 0, 0.07) 0px 3px 4px 0px',
                        // zIndex: 3005,
                        background: '#FFFFFF',
                      }}
                    >
                      {isLoading ? (
                        <li
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            padding: '15px 10px',
                            background: '#FFFFFF',
                          }}
                        >
                          <Spin spinning={isLoading} />
                        </li>
                      ) : (
                        keywordList?.slice(0, 10)?.map((item, index) => (
                          <li
                            key={`word-${index}`}
                            className="header-keyword"
                            onClick={(e) => {
                              e.preventDefault();
                              console.log('클릭!!!!!');
                              setSearchValue(item.search_word);
                              setIsFocus(false);
                            }}
                          >
                            {item.search_word}
                          </li>
                        ))
                      )}
                    </ul>
                  ) : null} */}
                </li>
                {/* <li>
                  <button onClick={() => navigate(`/products`)}>SHOP</button>
                </li>
                <li>
                  <button
                    onClick={
                      // () => window.open(`https://admin.jmcoffeemall.com/#/apply`)
                      () =>
                        window.open('https://jmcoffee.co.kr/contact/inquire/')
                    }
                  >
                    B2B PARTNERS
                  </button>
                </li>
                <li>
                  <button
                    onClick={() =>
                      window.open('https://jmcoffee.co.kr/products/artinus/')
                    }
                  >
                    ARTINUS
                  </button>
                </li>
                <li>
                  <button onClick={() => navigate(`/coupon&event`)}>
                    EVENT
                  </button>
                </li> */}

                {/* <li>
                  <button onClick={() => setIsDropped(!isDropped)}>
                    카테고리
                  </button>
                </li> */}
                {/* <li>
                  <button>베스트</button>
                </li>
                <li>
                  <button>신상품</button>
                </li> */}
                {/* <li>
                  <button>타임세일</button>
                </li> */}

                {/* <li>
                  <button
                    onClick={() =>
                      navigate(`/products?classification=promotion`)
                    }
                  >
                    기획전
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => navigate(`/products?classification=brand`)}
                  >
                    브랜드관
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => navigate(`/products?type=subscription`)}
                  >
                    정기배송
                  </button>
                </li>
                <li>
                  <button onClick={() => navigate(`/products?type=rental`)}>
                    렌탈
                  </button>
                </li>
                <li>
                  <button>선물하기</button>
                </li>
                <li>
                  <button onClick={() => navigate(`/coupon&event`)}>
                    이벤트
                  </button>
                </li> */}
              </ul>
            </li>

            {/* === Right === */}
            <li className="header_content inner03">
              <ul className="header_login_button">
                {!isLogin ? (
                  <React.Fragment>
                    <li>
                      <button type="link" onClick={() => navigate('/signin')}>
                        로그인
                      </button>
                    </li>
                    <li>
                      <button
                        type="link"
                        onClick={() => {
                          if (window.ReactNativeWebView) {
                            MessageAlert.info('order탭에서 진행해주세요.');
                            return;
                          }
                          navigate('/signup');
                        }}
                      >
                        회원가입
                      </button>
                    </li>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <li>
                      <span className="username">{name} 님</span>
                    </li>
                    <li>
                      <button type="link" onClick={() => onLogout()}>
                        로그아웃
                      </button>
                    </li>
                  </React.Fragment>
                )}
                <li>
                  <button
                    onClick={() =>
                      navigate('/cs/notice/hZsTD8bG3Kn2XCUKxyL1Ow%3D%3D')
                    }
                  >
                    등급혜택
                  </button>
                </li>
                {/* <li>
                  <button onClick={() => handleNavigate(`/mypage/order`, true)}>
                    배송조회
                  </button>
                </li> */}
                <li>
                  {/* <button type="link" onClick={() => navigate(`/cs/faq`)}>
                    고객센터
                  </button> */}
                  <Dropdown
                    menu={{ items }}
                    placement="bottom"
                    overlayStyle={{
                      zIndex: 9999999,
                      textAlign: 'center',
                      whiteSpace: 'nowrap',
                    }}
                    //onClick={() => navigate(`/cs/faq`)}
                  >
                    <Button>고객센터</Button>
                  </Dropdown>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {/* ===== 상단 메뉴: end ===== */}

        {/* ===== 하단 메뉴: start ===== */}
        <div
          className="header_layout bottom"
          style={{ backgroundColor: backgroundColor }}
        >
          <ul
            className="header_container bottom"
            style={{ maxWidth: maxWidth }}
          >
            {/* === Left: start === */}
            <li className="header_content inner01">
              <Button
                type="text"
                style={{ padding: 0 }}
                onClick={() => setIsDropped(!isDropped)}
              >
                <MenuOutlined /> <div className="pc all_menu">전체메뉴</div>
              </Button>
            </li>
            {/* === Left: end === */}

            {/* === Center: start === */}
            <li
              className="header_content inner02 menu"
              style={{ position: 'relative' }}
            >
              {/* 좌측 그라데이션 */}
              {hasScroll ? (
                <div
                  style={{
                    position: 'absolute',
                    width: 50,
                    height: '100%',
                    top: 0,
                    left: -10,
                    background:
                      'linear-gradient(to right, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%)',
                    zIndex: 3,
                    opacity: leftOpacity,
                    transition: 'opacity 0.3s ease-in-out',
                    pointerEvents: 'none',
                  }}
                />
              ) : null}

              <ul
                ref={navRef}
                className="header_nav"
                style={{
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                  whiteSpace: 'nowrap',
                  overflowX: screenSize >= 768 ? 'visible' : 'auto',
                }}
              >
                {[
                  {
                    title: 'Coffee', //기존 : 베스트
                    path: `/products?type=best`,
                  },
                  {
                    title: 'Machine & Goods', //기존 : 신상품
                    path: `/products?type=new`,
                  },
                  //{
                  //  title: 'Promotions',
                  //  path: '/products?type=promotions',
                  //},
                  {
                    title: 'Subscription', //기존 : 렌탈
                    path: '/products?type=rental',
                  },
                  {
                    title: 'Brands', //기존 : 브랜드관
                    path: `/brand`,
                  },
                  // {
                  //   title: '정기배송',
                  //   path: '/products?type=subscription',
                  // },

                  // {
                  //   title: 'JM Event',
                  //   path: '/events',
                  // },
                  // {
                  //   title: 'Recipe',
                  //   path: '/products?category=recipe',
                  // },
                  {
                    title: 'Gift', //기존 : 선물하기
                    path: '/products?type=present',
                  },
                ].map((item, index) => (
                  <li
                    key={`top_menu_${index}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate(item.path)}
                  >
                    {item.title}
                  </li>
                ))}
                <li className="jmdepth01">
                  <div style={{ cursor: 'default' }}>B2B</div>
                  <ul className="jmdepth02">
                    <li>
                      <a
                        target="_blank"
                        href="https://jmcoffee.co.kr/contact/inquire/"
                        rel="noreferrer"
                      >
                        원두 대량구매
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://jmcoffee.co.kr/artinus/%ec%95%84%ed%8b%b0%eb%88%84%ec%8a%a4-%ec%97%90%ec%8a%a4%ed%94%84%eb%a0%88%ec%86%8c-%eb%a8%b8%ec%8b%a0/"
                        rel="noreferrer"
                      >
                        카페 컨설팅
                      </a>
                    </li>
                    {/* <li>
                      <Link to={'/findstore'} target="_self">
                        Location
                      </Link>
                    </li> */}
                  </ul>
                </li>
                <li className="jmdepth01">
                  <div style={{ cursor: 'default' }}>Location</div>
                  <ul className="jmdepth02">
                    <li>
                      <Link to={'/findstore'} target="_self">
                        Jm Korea
                      </Link>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://jmcoffee.co.jp"
                        rel="noreferrer"
                      >
                        Jm Japan
                      </a>
                    </li>
                  </ul>
                </li>
                {/* <li className="mobile">
                  <Link to={'/findstore'} target="_self">
                    JM 매장찾기
                  </Link>
                </li> */}
              </ul>
              {/* 우측 그라데이션 */}
              {hasScroll ? (
                <div
                  style={{
                    position: 'absolute',
                    width: 50,
                    height: '100%',
                    top: 0,
                    right: -10,
                    background:
                      'linear-gradient(to left, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%)',
                    zIndex: 3,
                    opacity: rightOpacity,
                    transition: 'opacity 0.3s ease-in-out',
                    pointerEvents: 'none',
                  }}
                />
              ) : null}
            </li>
            {/* === Center: end === */}

            {/* === Right: start === */}
            <li className="header_content inner03">
              {/* <ul className="header_nav_icon"></ul> */}
              <ul className="header_nav_icon">
                {/* <li>
                  <button onClick={() => setIsOpened(true)}>
                    <img src={SearchIcon} alt="검색" />
                  </button>
                  <span className="header_nav_icon_text">SEARCH</span>
                </li> */}
                <li>
                  <Badge>
                    <button
                      onClick={() => handleNavigate(`/mypage/home`, true)}
                    >
                      <img src={UserIcon} alt="내정보" />
                    </button>
                  </Badge>
                  <span className="header_nav_icon_text">MY</span>
                </li>
                <li>
                  <Badge count={cartNum}>
                    <button
                      onClick={() =>
                        handleNavigate(`/order/cart?type=delivery`, true)
                      }
                    >
                      <img src={CartIcon} alt="장바구니" />
                    </button>
                  </Badge>
                  <span className="header_nav_icon_text">CART</span>
                </li>
                <li>
                  <Badge>
                    <button
                      onClick={() => handleNavigate(`/mypage/order`, true)}
                    >
                      <TruckOutlined
                        className="delivery"
                        style={{ color: '#111' }}
                      />
                    </button>
                  </Badge>
                  <span className="header_nav_icon_text">Delivery</span>
                </li>
                <li>
                  <button>
                    <img
                      src={ServiceIcon}
                      alt="고객센터"
                      onClick={() => window.open('http://pf.kakao.com/_xiZSZn')}
                    />
                  </button>
                  <span className="header_nav_icon_text">CS</span>
                </li>
              </ul>
            </li>
            {/* === Right: end === */}
          </ul>
        </div>
        {/* ===== 하단 메뉴: end ===== */}
      </div>
      {/* header_wrapper 끝 */}

      {/* 전체메뉴 카테고리 */}
      <RecursiveMenu
        menus={categories}
        isOpen={isDropped}
        onClose={() => setIsDropped(false)}
      />
      {/* <DropDownMenu isOpened={isDropped} menus={categories} /> */}

      {isOpened && (
        <SearchLayout
          maxWidth={maxWidth}
          logo={logo}
          onClose={() => setIsOpened(!isOpened)}
          recommend={recommendList}
          popular={popularList}
        />
      )}

      {/* 모바일 카테고리 */}
      {isAllOpen && (
        <ModalLayout
          maxWidth={'100%'}
          type="drawer"
          open={isAllOpen}
          onChange={setIsAllOpen}
          onCancel={() => setIsAllOpen(false)}
          closable
          style={{ backgroundColor: 'var(--beige-color)', padding: 0 }}
          headerStyle={{ backgroundColor: 'var(--beige-color)' }}
          title={'전체메뉴'}
        >
          <MobileAllMenu setIsAllOpen={setIsAllOpen} menus={categories} />
        </ModalLayout>
      )}
      {/* 모바일 카테고리 끝 */}

      {/* 모바일 마이페이지 메뉴 */}
      <ModalLayout
        maxWidth={'100%'}
        type="drawer"
        open={isOpen}
        onChange={setIsOpen}
        onCancel={() => setIsOpen(false)}
        closable
        style={{ backgroundColor: 'var(--beige-color)' }}
        headerStyle={{ backgroundColor: 'var(--beige-color)' }}
        title={'마이페이지'}
      >
        <MobileSideMenu
          setIsOpen={setIsOpen}
          isLogin={!!userInfo}
          name={userInfo?.user_name || ''}
          onLogout={handleLogout}
        />
      </ModalLayout>
      {/* 모바일 마이페이지 메뉴 끝 */}

      {/* 모바일 검색창 메뉴 */}
      {isSearchOpen && (
        <ModalLayout
          maxWidth={'100%'}
          type="drawer"
          open={isSearchOpen}
          onChange={setIsSearchOpen}
          onCancel={() => setIsSearchOpen(false)}
          closable
          //style={{ backgroundColor: 'var(--beige-color)' }}
          //headerStyle={{ backgroundColor: 'var(--beige-color)' }}
          title={'검색'}
        >
          <MobileSearch setIsSearchOpen={setIsSearchOpen} />
        </ModalLayout>
      )}
      {/* 모바일 검색창 메뉴 끝 */}

      {/* 모바일 CS 메뉴 */}
      <ModalLayout
        maxWidth={'100%'}
        type="drawer"
        open={isCsOpen}
        onChange={setIsCsOpen}
        onCancel={() => setIsCsOpen(false)}
        closable
        style={{ backgroundColor: 'var(--beige-color)' }}
        headerStyle={{ backgroundColor: 'var(--beige-color)' }}
        title={'CS'}
      >
        <MobileCsMenu setIsCsOpen={setIsCsOpen} />
      </ModalLayout>
      {/* 모바일 CS 메뉴 끝 */}
      {/* ===== mobile_header_wrapper 끝 ===== */}
    </OutsideClickHandler>
  );
};

export default MainHeader;
